/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import type { Partner } from '@oneaudi/audi-partner-utils';
import { useInViewEffect } from '@oneaudi/feature-app-utils';
import FeatureServiceContext from '../FeatureServiceContext';
import { useTrackingManager } from '../useTrackingManager';
import { PartnerBusinessCardFullLong } from './PartnerBusinessCardFullLong';
import { PartnerBusinessCardAddress } from './PartnerBusinessCardAddress';
import { PartnerBusinessCardTag } from './PartnerBusinessCardTag';
import { PartnerBusinessCardFixedNarrow } from './PartnerBusinessCardFixedNarrow';
import type { SocialMediaConfig } from './socialMedia/socialMediaBar';
import { createPartner } from './PartnerData';
import type { CtaBarButtonConfig } from './CtaBar';

import { PartnerProvider } from '../PartnerProvider';
import { layoutStyleStrings } from '../../constants';

const { selectedInfoNarrow, selectedInfoLong, dealerAddressAndContactInfo, dealerAndAddress } =
  layoutStyleStrings;

type PartnerBusinessCardState = {
  content?: ConfigProps;
};
type Dealers = {
  id: string;
  name: string;
};

type DealerContextLinkData = {
  context: string;
  dealerId: string;
  geoLocation: {
    lat: number;
    lon: number;
  };
  groupName: string;
  hasDealerAddressData: boolean;
  originalGroupName: string;
};
export type DealerPhone = {
  number: string;
  type: string;
};
export type VtpDealer = {
  city: string;
  dealerContextLinkData?: DealerContextLinkData[];
  email: string;
  geoLocation?: {
    lat: number;
    lon: number;
  };
  id: string;
  isAffiliateCompany?: boolean;
  name: string;
  phoneNumbers?: DealerPhone[];
  street: string;
  trackingId?: string;
  zipCode: string;
};

export type HeadlineOrder = '1' | '2' | '3' | '4';
export type HeadlineType =
  | 'caption'
  | 'div'
  | 'figcaption'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'label'
  | 'span';

export type VariantConfig = {
  contactDetails: {
    displayOpeningHours?: boolean;
    displayCtaBar?: boolean;
    displayOfficialName?: boolean;
    displayEmail?: boolean;
    displayPhone?: boolean;
    isLinkedToPWS?: boolean;
    showMoreInfoLink?: boolean;
    hasOuterSpacing?: boolean;
    isGoogleMapLink?: boolean;
    showImage?: boolean;
    showServiceList?: boolean;
    showJsonLd?: boolean;
    showJsonLdAutoDealer?: boolean;
    showSocialMediaLinks: boolean;
  };

  displayOpeningHours?: boolean;
  displayCtaBar?: boolean;
  displayOfficialName?: boolean;
  displayEmail?: boolean;
  displayPhone?: boolean;
  isLinkedToPWS?: boolean;
  showMoreInfoLink?: boolean;
  hasOuterSpacing?: boolean;
  isGoogleMapLink?: boolean;
  showImage?: boolean;
  showServiceList?: boolean;
  showJsonLd?: boolean;
  showJsonLdAutoDealer?: boolean;
  showSocialMediaLinks: boolean;
  headline?: {
    headlineTag: HeadlineType;
    headlineOrder: HeadlineOrder;
  };

  ctaBarButtonConfig?: CtaBarButtonConfig;
  socialMedia?: SocialMediaConfig;
};

export interface ConfigProps {
  partnerID: string;
  showVariant?: keyof typeof layoutStyleStrings;
  variantConfig?: VariantConfig | any;
  locale?: string;
  imprint?: string;
  registrationNumber?: string;
  countryCode?: string;
  isBevAgency?: boolean;
  isBEVAgency?: boolean;
  isBEVAgencyDealer?: boolean;
  nationWideSelling?: boolean;
  investorSharedVehicle?: boolean;
  dealers?: Dealers[];
  vtpDealerResultsURL?: string;
  vtpDealer: VtpDealer | undefined;
  dynamicLabel?: string | undefined;
  removePadding: boolean;
  headline?: {
    headlineTag: HeadlineType;
    headlineOrder: HeadlineOrder;
  };
  vtpPbcUrl?: string;
  vtpDealerSearchURL?: string;
}

export interface PartnerBusinessCardProps {
  config?: ConfigProps;
  data?: any;
}

export const PartnerBusinessCard = (props: PartnerBusinessCardProps): React.ReactElement => {
  const context = React.useContext(FeatureServiceContext);
  const [state, setState] = React.useState<PartnerBusinessCardState>({
    content: context.contentService?.getContent(),
  });
  const trackingManager = useTrackingManager();
  const { config, data } = props;

  context.contentService?.onContentChange(async () => {
    setState({ content: context.contentService?.getContent() });
  });

  const pbcvariant: string = config?.showVariant || state.content?.showVariant || selectedInfoLong;

  let partnerID: string;
  if (state.content?.partnerID) {
    partnerID = state.content?.partnerID;
  } else if (config?.partnerID) {
    partnerID = config?.partnerID;
  } else {
    (context.logger || console).debug('"partnerID" is missing! Partner data will not be fetched');
    // TODO Refactor component to render variants depending on partnerID is defined or not
    partnerID = '';
  }
  const [fetchedPartnerData, setFetchedPartnerData] = React.useState<Partner | undefined>(data);

  const partner = createPartner(fetchedPartnerData);

  const variantConfig: VariantConfig = config?.variantConfig
    ? config.variantConfig
    : state.content?.variantConfig;

  variantConfig.headline = config?.headline;

  React.useEffect(() => {
    if (data) {
      setFetchedPartnerData(data);
    }
  }, [data]);

  let vtpData: any;
  if (config) {
    const {
      imprint,
      registrationNumber,
      isBevAgency,
      isBEVAgency,
      isBEVAgencyDealer,
      investorSharedVehicle,
      nationWideSelling,
      dealers,
      vtpDealerResultsURL,
      vtpDealer,
      locale,
      dynamicLabel,
      vtpDealerSearchURL,
      vtpPbcUrl,
    } = config;
    vtpData = {
      imprint,
      registrationNumber,
      isBevAgency,
      isBEVAgency,
      isBEVAgencyDealer,
      investorSharedVehicle,
      nationWideSelling,
      dealers,
      vtpDealerResultsURL,
      vtpDealer,
      locale,
      dynamicLabel,
      vtpDealerSearchURL,
      vtpPbcUrl,
    };
  }

  React.useEffect(() => {
    if (typeof window !== 'undefined') trackingManager.pageLoad(pbcvariant, partnerID);
  }, [pbcvariant, partnerID, trackingManager]);

  // TODO refactor impression tracking only should happen when partner data are loaded!
  useInViewEffect(() => {
    trackingManager.impression(
      pbcvariant,
      partner?.nameEnhanced || '',
      partner?.openingHours?.departments,
      variantConfig?.ctaBarButtonConfig,
    );
  });

  if (partner || vtpData) {
    return (
      <PartnerProvider partner={partner}>
        {pbcvariant === selectedInfoLong && (
          <PartnerBusinessCardFullLong {...variantConfig} vtpData={vtpData} />
        )}
        {pbcvariant === dealerAddressAndContactInfo && (
          <PartnerBusinessCardAddress variantConfig={variantConfig} />
        )}
        {pbcvariant === dealerAndAddress && (
          <PartnerBusinessCardTag variantConfig={variantConfig} vtpData={vtpData} />
        )}
        {(pbcvariant === selectedInfoNarrow || pbcvariant === 'fixed-narrow') && (
          <PartnerBusinessCardFixedNarrow variantConfig={variantConfig} />
        )}
      </PartnerProvider>
    );
  }
  return <div />;
};
